import { render, staticRenderFns } from "./InstagramImage.vue?vue&type=template&id=79fe04fa"
import script from "./InstagramImage.vue?vue&type=script&lang=js"
export * from "./InstagramImage.vue?vue&type=script&lang=js"
import style0 from "./InstagramImage.vue?vue&type=style&index=0&id=79fe04fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports